<script>
    import { onMount } from "svelte";

    import { isMobile } from "../../stores";

    import {
        SearchInput,
        SvelteTable,
        PageLoading,
    } from "../../Components/Common/index.svelte";

    import { apiMethods } from "../../Services/index.svelte";

    import {
        replaceURL,
        getText,
        goToURL,
        showError,
        decodeSearchParams,
        encodeSearchParams,
        getBoolean,
    } from "../../Utils/utilFunctions.svelte";

    import TableFooter from "../../Components/Layout/Table/TableFooter.svelte";
    import { isEnvNewOrApp } from "../../Utils/utilRoute.svelte";

    import {
        user,
    } from "../../stores";


    export let params = {};

    let isGettingInsuranceFunds = false,
        returnInsuranceFundsArr = [],
        filters = {},
        page = 0,
        pageSize = 25,
        count;

    const columns = [
        {
            key: "name",
            title: "Insurance Fund Name",
            headerClass:
                `text-left px-3 ${(($user.role == 100 || $user.role == 80 || $user.role == 20) && isEnvNewOrApp()) ? 'w-4/12' : 'w-5/12'} sortable-header-decoration rounded-tl-xl`,
            class: `text-left px-3 ${(($user.role == 100 || $user.role == 80 || $user.role == 20) && isEnvNewOrApp()) ? 'w-6/12' : 'w-7/12'} cursor-pointer`,
            renderValue: (v) => getText(v.name),
        },
        {
            key: "eclipseCode",
            title: "Eclipse Code",
            headerClass: "text-left px-3 w-1/12 cursor-default",
            class: "text-left px-3 w-1/12 cursor-pointer",
            renderValue: (v) => (v.eclipseCode ? getText(v.eclipseCode) : "-"),
        },
        {
            key: "hcpCode",
            title: "HCP Code",
            headerClass: "text-left px-3 w-1/12 cursor-default",
            class: "text-left px-3 w-1/12 cursor-pointer",
            renderValue: (v) => (v.hcpCode ? getText(v.hcpCode) : "-"),
        },
        {
            key: "locationId",
            title: "Location ID",
            headerClass: `text-left px-3 w-2/12 cursor-default ${!(($user.role == 100 || $user.role == 80 || $user.role == 20) && isEnvNewOrApp()) ? 'rounded-tr-xl' : ''}`,
            class: "text-left px-3 w-2/12 cursor-pointer",
            renderValue: (v) => (v.locationId ? getText(v.locationId) : "-"),
        },
    ];

    $: isOverseasDisplayed =
        (($user.role == 100 || $user.role == 80 || $user.role == 20) && isEnvNewOrApp());

    const sortableHeaderKeys = ["name"];

    onMount(() => {
        if (params.query) updateSearchParamsByQuery(params.query);

        if(isOverseasDisplayed){
            columns.push({
                key: "isOverseas",
                title: "Overseas Insurance Enabled",
                headerClass: "text-left px-3 w-3/12 cursor-default rounded-tr-xl",
                class: "text-left px-3 w-3/12 cursor-pointer",
                renderValue: (v) => (v.isOverseas ? "Yes" : "No"),
            })
        }

        loadInsuranceFunds(page * pageSize, pageSize, _getSearchParams());
    });

    const updateSearchParamsByQuery = (query) => {
        const arr = decodeSearchParams(query).split("&");

        if (arr.length) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].includes("page="))
                    page = Number(arr[i].split("=")[1]);

                if (arr[i].includes("size="))
                    pageSize = Number(arr[i].split("=")[1]);

                if (arr[i].includes("search="))
                    filters.search = arr[i].split("=")[1].toString();

                if (arr[i].includes("sort="))
                    filters.sort = arr[i].split("=")[1].toString();
            }

            updateURL();
        }
    };

    const loadInsuranceFunds = async (start, limit, params) => {
        isGettingInsuranceFunds = true;
        if (params.sort) params.sort = params.sort.toLowerCase();

        await apiMethods.getMethod
            .getInsuranceFund(start, limit, params)
            .then((res) => _handleInsuranceFunds(res))
            .then(() => _updateHeaderSortIcon());

        isGettingInsuranceFunds = false;
    };

    const handleFilterSelect = () => {
        page = 0;

        updateURL();

        loadInsuranceFunds(0, pageSize, _getSearchParams());
    };

    const handleClickCell = ({ target: { className } }, rowData, key) => {
        if (rowData.id && key != "isNoGapGroup") {
            goToURL(`/InsuranceFunds/view/${rowData.id}`);
        }
    };

    const handleClickCol = ({ target: { className } }, rowData, key) => {
        if (sortableHeaderKeys.includes(key)) {
            if (filters.sort == key) filters.sort = `${key}Desc`;
            else filters.sort = key;
            updateURL();
            loadInsuranceFunds(0, pageSize, _getSearchParams());
        }
    };

    const _updateHeaderSortIcon = () => {
        let thRow = document.getElementsByTagName("th");
        const params = _getSearchParams();

        if (params) {
            setTimeout(() => {
                const upSpan = document.createElement("span");
                const downSpan = document.createElement("span");
                upSpan.innerHTML = `<i class="fas fa-sort-alpha-down" />`;
                upSpan.style = "font-size: 10px;";
                downSpan.innerHTML = `<i class="fas fa-sort-alpha-up-alt" />`;
                downSpan.style = "font-size: 10px;";

                Array.from(thRow).forEach((row) => {
                    if (
                        params.sort == "name" &&
                        row.childNodes[0].data == "Insurance Fund Name"
                    )
                        row.appendChild(upSpan);
                    else if (
                        params.sort == "nameDesc" &&
                        row.childNodes[0].data == "Insurance Fund Name"
                    )
                        row.appendChild(downSpan);
                });
            }, 0);
        }
    };

    const onPageChange = (e) => {
        page = Number(e.detail.page);

        updateURL();

        loadInsuranceFunds(
            Number(e.detail.firstDataIndex),
            pageSize,
            _getSearchParams(),
        );
    };

    const onPageSizeChange = (newPageSize) => {
        pageSize = newPageSize;
        page = 0;

        updateURL();

        loadInsuranceFunds(0, newPageSize, _getSearchParams());
    };

    const updateURL = () => {
        replaceURL(
            `/InsuranceFunds/page=${page}&size=${pageSize}${_getParamsString()}`,
        );
    };

    // HELPER FUNCTIONS
    const _handleInsuranceFunds = async (res) => {
        if (res.error) showError(res.error);
        else {
            returnInsuranceFundsArr = [...res.results];
            count = res.total;
        }
    };

    const _getSearchParams = () => {
        let params = {};
        if (filters.sort) params.sort = filters.sort;

        if (filters.search) params.search = filters.search;

        return params;
    };

    const _getParamsString = () => {
        let str = "";
        const params = _getSearchParams();

        if (params) {
            if (params.search) str += `&search=${params.search}`;
        }

        return encodeSearchParams(str);
    };
</script>

<div class="flex flex-col flex-1 gap-y-4">
    <div class="flex flex-col gap-y-4 flex-0">
        <div class="flex gap-4 flex-wrap">
            <SearchInput
                bind:value={filters.search}
                title="Search"
                inputFunc={handleFilterSelect}
                isLong
            />
        </div>
    </div>

    <div class={$isMobile ? "h-auto w-minus48" : "relative flex-1"}>
        {#if isGettingInsuranceFunds}
            <PageLoading />
        {:else}
            <div
                class={$isMobile
                    ? "overflow-x-auto overflow-y-visible"
                    : "overflow-y-auto absolute inset-0"}
            >
                <SvelteTable
                    {columns}
                    rows={returnInsuranceFundsArr}
                    clickCellFunc={({ detail: { event, row, key } }) => {
                        handleClickCell(event, row, key);
                    }}
                    clickColFunc={({ detail: { event, row, key } }) => {
                        handleClickCol(event, row, key);
                    }}
                    customRow="align-middle"
                />
            </div>
        {/if}
    </div>

    <TableFooter
        {page}
        {pageSize}
        {count}
        tableData={returnInsuranceFundsArr}
        {onPageChange}
        {onPageSizeChange}
        csvConfig={{
            columns,
            data: returnInsuranceFundsArr,
            fileName: "Insurance Funds",
            allDataApi: async () =>
                await apiMethods.getMethod.getInsuranceFund(
                    0,
                    999999,
                    _getSearchParams(),
                ),
        }}
    />
</div>
